import React from "react";
import Homepage from "./pages/homepage";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Services from "./pages/services";
import ContactPage from "./pages/contact";
import Leadership from "./pages/leadership";
import Aboutuspage from "./pages/aboutuspage";
import Questionspage from "./pages/questionspage";
import PrivacyPage from "./pages/privacy";
import TermsPage from "./pages/terms";
import AccessibilityPage from "./pages/accessibility";
import CookieBanner from "./components/CookieBanner";
import "./css/legal.css";

function App() {
  return (
    <React.Fragment>
      <a href="#main-content" className="skip-link">Skip to main content</a>
      <BrowserRouter>
        <CookieBanner />
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/services" element={<Services />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/leadership" element={<Leadership />} />
          <Route path="/about" element={<Aboutuspage />} />
          <Route path="/questions" element={<Questionspage />} />
          <Route path="/privacy" element={<PrivacyPage />} />
          <Route path="/terms" element={<TermsPage />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
        </Routes>
      </BrowserRouter>
    </React.Fragment>
  );
}

export default App;
